import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { map } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ReadyForContactFormComponent } from '../../components/ready-for-contact-form/ready-for-contact-form.component';
import { ModuleContainerDirective } from 'src/app/modules/directives/module-container.directive';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-support-page',
  standalone: true,
  imports: [
    CommonModule,
    ReadyForContactFormComponent,
    ModuleContainerDirective,
  ],
  templateUrl: './support-page.component.html',
  styleUrl: './support-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupportPageComponent {
  private readonly route = inject(ActivatedRoute);
  public readonly data$ = this.route.data.pipe(map(d => d['data']));
}
